import { defineMessages } from 'react-intl'

// E12 F12-5 (WI 633-637) — Settings > Federation Providers copy. Apostrophes use the curly ’ so the
// single-quote ESLint rule isn’t tripped (mirrors the Verified Domains messages).
const messages = defineMessages({
  title: {
    id: 'tenantSettings.federation.title',
    description: 'Federation Providers page title',
    defaultMessage: 'Federation Providers',
  },
  name: {
    id: 'tenantSettings.federation.name',
    description: 'Provider name column',
    defaultMessage: 'Name',
  },
  providerType: {
    id: 'tenantSettings.federation.providerType',
    description: 'Provider type column',
    defaultMessage: 'Type',
  },
  domains: {
    id: 'tenantSettings.federation.domains',
    description: 'Domains column',
    defaultMessage: 'Domains',
  },
  status: {
    id: 'tenantSettings.federation.status',
    description: 'Status column',
    defaultMessage: 'Status',
  },
  statusActive: {
    id: 'tenantSettings.federation.statusActive',
    description: 'Active status chip',
    defaultMessage: 'Active',
  },
  statusDisabled: {
    id: 'tenantSettings.federation.statusDisabled',
    description: 'Disabled status chip',
    defaultMessage: 'Disabled',
  },
  lastUpdate: {
    id: 'tenantSettings.federation.lastUpdate',
    description: 'Last update column',
    defaultMessage: 'Updated',
  },
  addProvider: {
    id: 'tenantSettings.federation.addProvider',
    description: 'Add provider button',
    defaultMessage: 'Add provider',
  },
  edit: {
    id: 'tenantSettings.federation.edit',
    description: 'Edit action',
    defaultMessage: 'Edit',
  },
  remove: {
    id: 'tenantSettings.federation.remove',
    description: 'Remove action',
    defaultMessage: 'Remove',
  },
  confirmRemoveTitle: {
    id: 'tenantSettings.federation.confirmRemoveTitle',
    description: 'Confirm remove title',
    defaultMessage: 'Remove federation provider?',
  },
  confirmRemoveBody: {
    id: 'tenantSettings.federation.confirmRemoveBody',
    description: 'Confirm remove body',
    defaultMessage: 'Remove {name}? Users on its domains will no longer be able to sign in through it.',
  },
  cancel: {
    id: 'tenantSettings.federation.cancel',
    description: 'Cancel button',
    defaultMessage: 'Cancel',
  },
  providerRemoved: {
    id: 'tenantSettings.federation.providerRemoved',
    description: 'Provider removed toast',
    defaultMessage: 'Federation provider removed.',
  },
  disabledReason: {
    id: 'tenantSettings.federation.disabledReason',
    description: 'Disabled provider failure-reason detail',
    defaultMessage: 'Auto-disabled: {reason}',
  },
  domainUnverifiedCaution: {
    id: 'tenantSettings.federation.domainUnverifiedCaution',
    description: 'Unverified federation domain caution tooltip',
    defaultMessage: 'This domain is not linked to a verified domain — sign-in through it is blocked until you re-link it.',
  },

  // --- Wizard ---
  wizardTitle: {
    id: 'tenantSettings.federation.wizardTitle',
    description: 'Add-provider wizard title',
    defaultMessage: 'Add federation provider',
  },
  stepType: {
    id: 'tenantSettings.federation.stepType',
    description: 'Wizard step 1 label',
    defaultMessage: 'Provider',
  },
  stepDomains: {
    id: 'tenantSettings.federation.stepDomains',
    description: 'Wizard step 3 label',
    defaultMessage: 'Domains',
  },
  stepReview: {
    id: 'tenantSettings.federation.stepReview',
    description: 'Wizard step 4 label',
    defaultMessage: 'Review',
  },
  typeLabel: {
    id: 'tenantSettings.federation.typeLabel',
    description: 'Provider type field',
    defaultMessage: 'Provider type',
  },
  nameLabel: {
    id: 'tenantSettings.federation.nameLabel',
    description: 'Provider name field',
    defaultMessage: 'Display name',
  },
  domainsHint: {
    id: 'tenantSettings.federation.domainsHint',
    description: 'Domains step help text',
    defaultMessage: 'Choose which of your verified domains route to this provider. Only verified domains can be federated.',
  },
  noVerifiedDomains: {
    id: 'tenantSettings.federation.noVerifiedDomains',
    description: 'No verified domains available',
    defaultMessage: 'You have no verified domains. Verify a domain first, then add a federation provider.',
  },
  reviewDomains: {
    id: 'tenantSettings.federation.reviewDomains',
    description: 'Review domains label',
    defaultMessage: 'Domains',
  },
  back: {
    id: 'tenantSettings.federation.back',
    description: 'Back button',
    defaultMessage: 'Back',
  },
  next: {
    id: 'tenantSettings.federation.next',
    description: 'Next button',
    defaultMessage: 'Next',
  },
  create: {
    id: 'tenantSettings.federation.create',
    description: 'Create provider button',
    defaultMessage: 'Create provider',
  },
  creating: {
    id: 'tenantSettings.federation.creating',
    description: 'Creating in progress',
    defaultMessage: 'Creating…',
  },
  providerCreated: {
    id: 'tenantSettings.federation.providerCreated',
    description: 'Provider created toast',
    defaultMessage: 'Federation provider created.',
  },
  createFailed: {
    id: 'tenantSettings.federation.createFailed',
    description: 'Create provider failed, when the server sent no message',
    defaultMessage: 'The federation provider couldn’t be created. Please try again.',
  },
  reconnectMicrosoft: {
    id: 'tenantSettings.federation.reconnectMicrosoft',
    description: 'Button that restarts the Connect Microsoft step after the consent can no longer be used',
    defaultMessage: 'Connect Microsoft again',
  },

  // --- Connect Microsoft (E20 admin consent, WI 794) ---
  stepConnect: {
    id: 'tenantSettings.federation.stepConnect',
    description: 'Wizard step 2 label',
    defaultMessage: 'Connect',
  },
  connectHint: {
    id: 'tenantSettings.federation.connectHint',
    description: 'Connect step help text',
    defaultMessage:
      'Connect your Microsoft organisation so your domains can be verified automatically. A Microsoft administrator will be asked to approve the connection — you can do it yourself, or forward the link to whoever manages Microsoft in your organisation.',
  },
  connectMicrosoft: {
    id: 'tenantSettings.federation.connectMicrosoft',
    description: 'Connect Microsoft button',
    defaultMessage: 'Connect Microsoft',
  },
  connectStarting: {
    id: 'tenantSettings.federation.connectStarting',
    description: 'Connect Microsoft in progress',
    defaultMessage: 'Starting…',
  },
  consentWaiting: {
    id: 'tenantSettings.federation.consentWaiting',
    description: 'Waiting for admin consent',
    defaultMessage:
      'Waiting for a Microsoft administrator to approve the connection. Open the approval page yourself, or copy the link and forward it — this page updates automatically.',
  },
  // Resumed by key, or waiting on a round trip the server reissued: the live link exists only on the
  // administrator's error page, so this wizard has nothing to offer.
  consentWaitingNoLink: {
    id: 'tenantSettings.federation.consentWaitingNoLink',
    description: 'Waiting for admin consent, with no link to offer from here',
    defaultMessage:
      'Waiting for a Microsoft administrator to approve the connection. This page updates automatically.',
  },
  openConsentPage: {
    id: 'tenantSettings.federation.openConsentPage',
    description: 'Open consent page button',
    defaultMessage: 'Open the approval page',
  },
  copyConsentLink: {
    id: 'tenantSettings.federation.copyConsentLink',
    description: 'Copy consent link button',
    defaultMessage: 'Copy link',
  },
  consentLinkCopied: {
    id: 'tenantSettings.federation.consentLinkCopied',
    description: 'Consent link copied toast',
    defaultMessage: 'Link copied.',
  },
  consentCompleted: {
    id: 'tenantSettings.federation.consentCompleted',
    description: 'Consent completed message',
    defaultMessage: 'Microsoft connection approved.',
  },
  consentDeclined: {
    id: 'tenantSettings.federation.consentDeclined',
    description: 'Consent declined message',
    defaultMessage: 'The Microsoft administrator declined the connection.',
  },
  consentExpired: {
    id: 'tenantSettings.federation.consentExpired',
    description: 'Consent expired message',
    defaultMessage: 'The connection request expired before it was approved.',
  },
  consentFailed: {
    id: 'tenantSettings.federation.consentFailed',
    description: 'Consent failed message',
    defaultMessage: 'The connection couldn’t be completed.',
  },
  consentReference: {
    id: 'tenantSettings.federation.consentReference',
    description: 'Consent failure support reference',
    defaultMessage: 'Support reference: {correlationId}',
  },
  consentRetry: {
    id: 'tenantSettings.federation.consentRetry',
    description: 'Consent retry button',
    defaultMessage: 'Try again',
  },

  // --- Public consent landing (/federation-consent/:key) ---
  consentPageSuccessTitle: {
    id: 'tenantSettings.federation.consentPageSuccessTitle',
    description: 'Consent landing success title',
    defaultMessage: 'Consent recorded',
  },
  consentPageSuccessBody: {
    id: 'tenantSettings.federation.consentPageSuccessBody',
    description: 'Consent landing success body',
    defaultMessage:
      'Thanks — the Microsoft connection has been approved. The LogikSpark account owner can now finish setting up single sign-on. You can close this window.',
  },

  // --- Edit modal ---
  editTitle: {
    id: 'tenantSettings.federation.editTitle',
    description: 'Edit provider modal title',
    defaultMessage: 'Edit {name}',
  },
  editDomainsHeading: {
    id: 'tenantSettings.federation.editDomainsHeading',
    description: 'Edit modal domains heading',
    defaultMessage: 'Domains',
  },
  addDomainButton: {
    id: 'tenantSettings.federation.addDomainButton',
    description: 'Add domain button',
    defaultMessage: 'Add domain',
  },
  linkButton: {
    id: 'tenantSettings.federation.linkButton',
    description: 'Link domain to verified-domain action',
    defaultMessage: 'Link',
  },
  verifiedDomainLabel: {
    id: 'tenantSettings.federation.verifiedDomainLabel',
    description: 'Verified-domain picker label',
    defaultMessage: 'Verified domain',
  },
  domainAdded: {
    id: 'tenantSettings.federation.domainAdded',
    description: 'Domain added toast',
    defaultMessage: 'Domain added.',
  },
  domainRemoved: {
    id: 'tenantSettings.federation.domainRemoved',
    description: 'Domain removed toast',
    defaultMessage: 'Domain removed.',
  },
  domainLinked: {
    id: 'tenantSettings.federation.domainLinked',
    description: 'Domain linked toast',
    defaultMessage: 'Domain linked to its verified domain.',
  },
})

export default messages
